import React from "react";
import { Breadcrumb, Layout, Button } from "antd";
import { Link } from "react-router-dom";
import { App } from "context/AppContext";
import { AntdIcon } from "components";

const { Content } = Layout;

const Page = ({ children, breadcrumb, ...props }) => {
  const { darkMode } = App();

  return (
    <div style={{ height: "100%" }}>
      {breadcrumb && (
        <Breadcrumb style={{ padding: "10px" }} separator={AntdIcon("CaretRightOutlined")}>
          <Breadcrumb.Item>
            <Link to={"/"}>
              <Button icon={AntdIcon("HomeFilled")} type="link" />
            </Link>
          </Breadcrumb.Item>
          {breadcrumb.map((item, index) => {
            return (
              <Breadcrumb.Item key={index}>
                {item.href ? (
                  <Link to={item.href}>
                    <Button icon={AntdIcon(item.icon)} type="link">
                      {item.text}
                    </Button>
                  </Link>
                ) : (
                  <Button icon={AntdIcon(item.icon)} disabled>
                    {item.text}
                  </Button>
                )}
              </Breadcrumb.Item>
            );
          })}
        </Breadcrumb>
      )}
      <Content style={{ padding: "20px", height: "100%", backgroundColor: darkMode ? "#141414" : "#fff" }}>
        {children}
      </Content>
    </div>
  );
};

export default Page;
